import { CustomerDataContext } from '@/common/components/layout/productLayout/context/CustomerDataContext';
import { useContext, useEffect } from 'react';

const englishId = '66c6e560fc64db42edc80807';

const useLearn = () => {
	const {
		userData,
		learnData,
		handleLoadLearnDataMutation,
		manageFavoriteMutation,
		favoriteArr,
	} = useContext(CustomerDataContext);

	const handleAddToFavorite = (id, type) => {
		const payload = {
			_id: id,
			type,
			shouldAdd: !favoriteArr?.includes(id),
		};

		manageFavoriteMutation.mutate(payload);
	};

	const isScenesV3 =
		userData?.tests?.scenesV3 && userData?.learningLanguage === englishId;
	const scenesToDisplay = isScenesV3 ? learnData?.scenesV3 : learnData?.scenes;
	const scenesType = isScenesV3 ? 'scenes_v3' : 'scenes';

	useEffect(() => {
		window.document.title = 'Synthi Ai - Learn';
	}, []);

	return {
		learnData,
		favoriteArr,
		scenesToDisplay,
		scenesType,
		handleAddToFavorite,
		isLoading:
			handleLoadLearnDataMutation.isLoading || manageFavoriteMutation.isLoading,
	};
};

export default useLearn;
